var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor5',{attrs:{"editor":_vm.editor,"config":Object.assign({}, {placeholder: _vm.placeholder}, _vm.editorConfig),"value":_vm.value || ''},on:{"ready":_vm.onReady,"input":function (value) { return _vm.$emit('input', value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }